module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 78
// module chunks = 0